<template>
  <component :is="componentName" v-model="searchModal" :info="info.config" :index="index" @close="close" @add="add" ></component>
</template>

<script>
import customSearchType1 from "@components/En/custom-component/common/custom-search/components/custom-search-type-1.vue";
export default {
  // 标题类型 1
  name: "custom-title",
  model: {
    prop: "searchModal",
    event: "sendSearchModal"
  },
  props: { 
    index: {
      type: Number,
      default: 0,
    },
    info: {
      type: Object,
      default: {
        title: "产品搜索",
        icon: "icon-sousuo",
        type: "search",
        componentName: "customSearch",
        config: {
          type: 1, // 搜索类型 暂时只有 1
          words: [],
          style: "circular", // 搜索外边框样式 （圆 \ 方）
          position: "left", // 文本对齐格式
          color: "#ccc",
          background: "#f5f5f5",
          borderColor: "#91c0ec"
        }
      }
    },
    searchModal: {
      type: Object,
      default: function() {
        return {
          type: 1, // 搜索类型 暂时只有 1
          words: [""],
          style: "circular", // 搜索外边框样式 （圆 \ 方）
          position: "left", // 文本对齐格式
          color: "#ccc",
          background: "#f5f5f5",
          borderColor: "#91c0ec"
        }
      }
    }
  },
  computed: {
    componentName() {
      return `customSearchType${this.info.config.type}`;
    }
  },
  data() {
    return {};
  },
  components: {
    customSearchType1
  },
  methods: {
    close() {
      this.$emit('close');
    },
    add(item, idx) { 
      this.$emit('add', item, idx);
    },
  }
};
</script>

<style scoped lang="scss">
</style>
